import { render, staticRenderFns } from "./CurriculumMenuT.vue?vue&type=template&id=4f31a942&scoped=true&"
import script from "./CurriculumMenuT.vue?vue&type=script&lang=ts&"
export * from "./CurriculumMenuT.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumMenuT.vue?vue&type=style&index=0&id=4f31a942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31a942",
  null
  
)

export default component.exports